<template>
  <div>
    <div class="content">
      <div class="titlePart">信用数据查询</div>
      <div style="height:100%">
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding: 0 30px 0"
        >
        <el-form-item label="统一社会信用代码">
            <el-input
              style="width: 200px;"
              placeholder="请输入统一社会信用代码"
              v-model.trim="searchForm.enterpriseCode"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="企业名称">
            <el-input
              style="width: 200px;"
              placeholder="请输入企业名称"
              v-model.trim="searchForm.name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchFunction">查询</el-button>
            <!-- <el-button type="primary" plain @click="downJson">下载</el-button> -->
          </el-form-item>
        </el-form>
        <div class="contentClass" v-show="showLog">
          <p>查询不到结果，请重新核对统一社会信用代码或企业名称</p>
        </div>
        <div v-if="!showLog&&time!=0" class="itemDiv">
          <div  v-for="item in tree" :key="item.id" style="padding-left: 30px;">
              <div style="display: flex; align-items: center; cursor: pointer; margin:20px 0;" @click="toggleExpand(item.id)">
                <span class="arrow-icon triangle" :class="{expanded: expandedItems[item.id]}"></span>
                <span style="font-weight: 600;font-size: 16px;">{{item.label}}</span>
              </div>
              <div v-if="expandedItems[item.id]">
                <div v-for="child in item.children" :key="child.id">
                  <div style="padding-left: 30px;margin-top: 16px;">
                    <div style="display: flex; align-items: center; cursor: pointer;" v-if="child.children && (child.children.length > 0 || child.children !== null)" @click.stop="toggleExpandChild(item.id, child.id)">
                      <span 
                        class="arrow-icon triangle" 
                        :class="{expanded: expandedChildItems[`${item.id}-${child.id}`]}"
                        style="cursor: pointer;"
                      ></span>
                      <span style="font-size: 15px;">{{ child.label }} </span>
                    </div>
                    <div style="display: flex; align-items: center;" v-else>
                      <span style="width: 18px;"></span>
                      <span style="font-size: 15px;">{{ child.label }}</span>
                    </div>
                    <!-- 市场主体登记信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'registration_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="zs" label="住所" width="180"></el-table-column>
                        <el-table-column prop="SCSJ" label="上传时间" width="180"></el-table-column>
                        <el-table-column prop="frlb" label="法人类别" width="180"></el-table-column>
                        <el-table-column prop="hzrq" label="核准日期" width="180"></el-table-column>
                        <el-table-column prop="jyfw" label="经营范围" width="180"></el-table-column>
                        <el-table-column prop="lxdh" label="联系电话" width="180"></el-table-column>
                        <el-table-column prop="qyzt" label="企业状态" width="180"></el-table-column>
                        <el-table-column prop="ssdq" label="所属区域" width="180"></el-table-column>
                        <el-table-column prop="sshy" label="所属行业" width="180"></el-table-column>
                        <el-table-column prop="yzbm" label="邮政编码" width="180"></el-table-column>
                        <el-table-column prop="zcbz" label="注册资本币种" width="180"></el-table-column>
                        <el-table-column prop="zczj" label="注册资本" width="180"></el-table-column>
                        <el-table-column prop="recid" label="记录ID" width="180"></el-table-column>
                        <el-table-column prop="djjgmc" label="登记机构名称" width="180"></el-table-column>
                        <el-table-column prop="qylxmc" label="企业类型名称" width="180"></el-table-column>
                        <el-table-column prop="zcdjrq" label="注册登记日期" width="180"></el-table-column>
                        <el-table-column prop="zzjgdm" label="组织机构代码" width="180"></el-table-column>
                        <el-table-column prop="fddbrxm" label="法定代表人姓名" width="180"></el-table-column>
                        <el-table-column prop="frsshydm" label="法人所属行业代码" width="180"></el-table-column>
                        <el-table-column prop="zczj_rmb" label="注册资本(人民币)" width="180"></el-table-column>
                        <el-table-column prop="sshy_code" label="所属行业代码" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 社会保险费缴纳情况 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'social_insurance_payment_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="payment_cycle" label="缴纳周期（月）" width="180"></el-table-column>
                        <el-table-column prop="payment_month" label="缴纳月份" width="180"></el-table-column>
                        <el-table-column prop="insured_number" label="参保人数" width="180"></el-table-column>
                        <el-table-column prop="payment_times" label="缴纳次数" width="180"></el-table-column>
                        <el-table-column prop="payment_amount" label="缴纳金额" width="180"></el-table-column>
                        <el-table-column prop="whether_arrears" label="是否欠费" width="180"></el-table-column>
                        <el-table-column prop="arrears_amount" label="欠费金额" width="180"></el-table-column>
                      </el-table>
                    </div>
                    
                    <!-- 企业主名下不动产抵押信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'enterprise_real_estate_mortgage'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="gz" label="估值(万元)" width="180"></el-table-column>
                        <el-table-column prop="mj" label="面积" width="180"></el-table-column>
                        <el-table-column prop="yt" label="用途" width="180"></el-table-column>
                        <el-table-column prop="zl" label="坐落" width="180"></el-table-column>
                        <el-table-column prop="lxr" label="联系人" width="180"></el-table-column>
                        <el-table-column prop="djsj" label="登记时间" width="180"></el-table-column>
                        <el-table-column prop="fezb" label="份额占比" width="180"></el-table-column>
                        <el-table-column prop="gyqk" label="共有情况" width="180"></el-table-column>
                        <el-table-column prop="lxdh" label="联系电话" width="180"></el-table-column>
                        <el-table-column prop="tgrq" label="提供日期" width="180"></el-table-column>
                        <el-table-column prop="bdclx" label="不动产类型" width="180"></el-table-column>
                        <el-table-column prop="djjgqc" label="登记机关全称" width="180"></el-table-column>
                        <el-table-column prop="mjjldw" label="面积计量单位" width="180"></el-table-column>
                        <el-table-column prop="tgdwqc" label="提供单位全称" width="180"></el-table-column>
                        <el-table-column prop="bdcdyzt" label="不动产抵押状态(它项权益)" width="200"></el-table-column>
                        <el-table-column prop="bdcqzsh" label="不动产权证书号。" width="180"></el-table-column>
                        <el-table-column prop="qlrtxdz" label="权利人通讯地址" width="180"></el-table-column>
                        <el-table-column prop="xxytbmqc" label="信息源头部门全称" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 企业主名下不动产登记信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'enterprise_real_estate_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="gz" label="估值(万元)" width="180"></el-table-column>
                        <el-table-column prop="mj" label="面积" width="180"></el-table-column>
                        <el-table-column prop="yt" label="用途" width="180"></el-table-column>
                        <el-table-column prop="zl" label="坐落" width="180"></el-table-column>
                        <el-table-column prop="lxr" label="联系人" width="180"></el-table-column>
                        <el-table-column prop="djsj" label="登记时间" width="180"></el-table-column>
                        <el-table-column prop="fezb" label="份额占比" width="180"></el-table-column>
                        <el-table-column prop="gyqk" label="共有情况" width="180"></el-table-column>
                        <el-table-column prop="lxdh" label="联系电话" width="180"></el-table-column>
                        <el-table-column prop="tgrq" label="提供日期" width="180"></el-table-column>
                        <el-table-column prop="bdclx" label="不动产类型" width="180"></el-table-column>
                        <el-table-column prop="djjgqc" label="登记机关全称" width="180"></el-table-column>
                        <el-table-column prop="mjjldw" label="面积计量单位" width="180"></el-table-column>
                        <el-table-column prop="tgdwqc" label="提供单位全称" width="180"></el-table-column>
                        <el-table-column prop="bdcdyzt" label="不动产抵押状态(它项权益)" width="200"></el-table-column>
                        <el-table-column prop="bdcqzsh" label="不动产权证书号。" width="180"></el-table-column>
                        <el-table-column prop="qlrtxdz" label="权利人通讯地址" width="180"></el-table-column>
                        <el-table-column prop="xxytbmqc" label="信息源头部门全称" width="180"></el-table-column>
                      </el-table>
                    </div>
                    
                    <!-- 电费信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'electricity_fee_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="usernum" label="用户名称" width="180"></el-table-column>
                        <el-table-column prop="user_address" label="用户地址" width="180"></el-table-column>
                        <el-table-column prop="statistical_date" label="统计日期" width="180"></el-table-column>
                        <el-table-column prop="account_status" label="账户状态" width="180"></el-table-column>
                        <el-table-column prop="contract_capacity" label="合同容量（kW）" width="180"></el-table-column>
                        <el-table-column prop="operating_capacity" label="运行容量（kW）" width="180"></el-table-column>
                        <el-table-column prop="first_time" label="首次使用时间" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 医保定点民营医疗机构信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'private_medical_insurance_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="medical_institution_practice_l" label="定点民营医疗机构代码" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 企业缓税信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'tax_deferral_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="hsxm" label="缓税项目" width="180"></el-table-column>
                        <el-table-column prop="hsje" label="缓税金额" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 补贴信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'agricultural_subsidy_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="types_of_subsidies" label="补贴项目" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 纳税历史欠税信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'historical_tax_arrears_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="jkrq" label="缴税日期" width="180"></el-table-column>
                        <el-table-column prop="ssqq" label="所属期起" width="180"></el-table-column>
                        <el-table-column prop="qsje" label="欠税金额" width="180"></el-table-column>
                        <el-table-column prop="ssqz" label="所属期止" width="180"></el-table-column>
                        <el-table-column prop="sz" label="税种" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 保险信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'agricultural_insurance_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="insurance_type" label="保险类型" width="180"></el-table-column>
                        <el-table-column prop="is_insurance_information" label="是否参保" width="180"></el-table-column>
                        <el-table-column prop="effective_period_of_insu_start" label="参保开始时间" width="180"></el-table-column>
                        <el-table-column prop="effective_period_of_insu_end" label="参保结束时间" width="180"></el-table-column>
                        <el-table-column prop="insurance_fee" label="保险费用" width="180"></el-table-column>
                        <el-table-column prop="insurance_coverage" label="保险范围" width="180"></el-table-column>
                        <el-table-column prop="insurance_claim_information" label="理赔信息" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 涉农类清单信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'large_farmer_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="address" label="用户地址" width="180"></el-table-column>
                        <el-table-column prop="name" label="用户名称" width="180"></el-table-column>
                        <el-table-column prop="remark" label="备注" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 企业商标信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'enterprise_trademark_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="exclusive_period_begin" label="专用权期限开始" width="160"></el-table-column>
                        <el-table-column prop="application_date" label="申请日期" width="120"></el-table-column>
                        <el-table-column prop="application_number" label="申请号/注册号"  width="120"></el-table-column>
                        <el-table-column prop="exclusive_period_end" label="专用权期限结束" width="180"></el-table-column>
                        <el-table-column prop="category" label="商标类别" ></el-table-column>
                        <el-table-column prop="applicant_name" label="申请人名称" width="180"></el-table-column>
                        <el-table-column prop="trademark_name" label="商标名称" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 企业职工基本养老保险缴费信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'pension_insurance_payment_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="payment_cycle" label="缴费周期时间" width="180"></el-table-column>
                        <el-table-column prop="payment_month" label="缴费月份" width="180"></el-table-column>
                        <el-table-column prop="insured_number" label="参保人数数"  width="180"></el-table-column>
                        <el-table-column prop="payment_times" label="缴费次数数" width="180"></el-table-column>
                        <el-table-column prop="payment_amount" label="缴费金额" width="180"></el-table-column>
                        <el-table-column prop="whether_arrears" label="是否欠费" width="180"></el-table-column>
                        <el-table-column prop="arrears_amount" label="欠费金额" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 科技研发信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'technology_rd_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="nation_hightech_enterprise" label="国家高科技企业" width="180"></el-table-column>
                        <el-table-column prop="technology_enterprises" label="科技研发企业" width="180"></el-table-column>
                        <el-table-column prop="hdrq" label="研发日期"  width="180"></el-table-column>
                        <el-table-column prop="support_information" label="支持信息" width="180"></el-table-column>
                        <el-table-column prop="highandnew_enterprises" label="高新企业" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 企业黑名单信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'blacklist_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="uniscId" label="统一社会信用代码" width="180"></el-table-column>
                        <el-table-column prop="reason" label="黑名单原因" width="180"></el-table-column>
                        <el-table-column prop="endDate" label="黑名单结束时间"  width="180"></el-table-column>
                        <el-table-column prop="listedDepartment" label="黑名单部门" width="180"></el-table-column>
                        <el-table-column prop="category" label="黑名单分类" width="180"></el-table-column>
                        <el-table-column prop="enterpriseName" label="企业名称" width="180"></el-table-column>
                        <el-table-column prop="startDate" label="黑名单开始时间" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 职工医疗保险费基本信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'employee_medical_insurance_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="insurance" label="医疗保险费" width="180"></el-table-column>
                        <el-table-column prop="last_payment_month" label="最后缴纳月份" width="180"></el-table-column>
                        <el-table-column prop="delayed_payment_amount_and_dat" label="延迟缴纳金额和日期"  width="180"></el-table-column>
                        <el-table-column prop="remark" label="备注" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 非正常纳税户信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'abnormal_taxpayer_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="nsrzt" label="非正常纳税户状态" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 纳税信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'tax_payment_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="zsxmmc" label="纳税项目" width="180"></el-table-column>
                        <el-table-column prop="skssqq" label="税款所属期起" width="120"></el-table-column>
                        <el-table-column prop="qsje" label="纳税金额" width="180"></el-table-column>
                        <el-table-column prop="skssqz" label="纳税日期" width="120"></el-table-column>
                        <el-table-column prop="jkrq" label="纳税日期" width="120"></el-table-column>
                        <el-table-column prop="sfqs" label="是否纳税" ></el-table-column>
                      </el-table>
                    </div>
                    <!-- 企业行政强制信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'administrative_force_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="uniscId" label="企业行政强制编号" width="180"></el-table-column>
                        <el-table-column prop="executeType" label="执行类型" width="120"></el-table-column>
                        <el-table-column prop="forceBasis" label="强制依据" width="180"></el-table-column>
                        <el-table-column prop="administrativeOrgUniscId" label="行政组织编号" width="120"></el-table-column>
                        <el-table-column prop="forceDecisionNumber" label="强制决定编号" width="120"></el-table-column>
                        <el-table-column prop="forceReason" label="强制原因" width="180"></el-table-column>
                        <el-table-column prop="forceDecisionName" label="强制决定名称" width="180"></el-table-column>
                        <el-table-column prop="enterpriseName" label="企业名称" width="180"></el-table-column>
                        <el-table-column prop="dataSource" label="数据来源" width="180"></el-table-column>
                        <el-table-column prop="administrativeOrgName" label="行政组织名称" width="180"></el-table-column>
                        <el-table-column prop="legalPersonName" label="法人名称" width="180"></el-table-column>
                        <el-table-column prop="executeTime" label="执行日期" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 自然人黑名单接口 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'person_black_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="hasBlack" label="是否黑名单人" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 法院判决信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'court_judgment_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="caseNumber" label="案号" width="180"></el-table-column>
                        <el-table-column prop="caseReason" label="案由" width="180"></el-table-column>
                        <el-table-column prop="court" label="执行法院名称" width="180"></el-table-column>
                        <el-table-column prop="enterpriseName" label="企业名称" width="180"></el-table-column>
                        <el-table-column prop="location" label="所在地" width="180"></el-table-column>
                        <el-table-column prop="publishTime" label="发布日期" width="180"></el-table-column>
                        <el-table-column prop="result" label="判决结果" width="180"></el-table-column>
                        <el-table-column prop="uniscId" label="统一社会信用代码" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 财务申报信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'financial_reporting_info'">
                      <div style="font-size: 14px;padding-left: 20px;margin-top:10px">资产负债表信息:</div>
                      <el-table max-height="600" :data="child.children.zcfzbxx" style="width: 100%">
                          <el-table-column prop="ssqq" label="所属期起" width="180"></el-table-column>
                          <el-table-column prop="qyxmmc" label="权益项目名称" width="180"></el-table-column>
                          <el-table-column prop="djxh" label="登记序号" width="120"></el-table-column>
                          <el-table-column prop="ncsQy" label="年初数权益" width="120"></el-table-column>
                          <el-table-column prop="ncsZc" label="年初数资产" width="220"></el-table-column>
                          <el-table-column prop="nmsZc" label="年末数资产(期末余额资产)" width="200"></el-table-column>
                          <el-table-column prop="ewbhxh" label="二维表行序号" width="120"></el-table-column>
                          <el-table-column prop="zcxmmc" label="资产项目名称" width="120"></el-table-column>
                          <el-table-column prop="ssqz" label="所属期止" width="120"></el-table-column>
                          <el-table-column prop="nmsQy" label="年末数权益(期末余额权益)" width="200"></el-table-column>
                        </el-table>
                        <div style="font-size: 14px;padding-left: 20px;margin-top:30px">利润表信息:</div>
                        <el-table max-height="600" :data="child.children.lrbxx" style="width: 100%;margin-top: 20px;">
                          <el-table-column prop="snje" label="上年金额(上年数)" width="180"></el-table-column>
                          <el-table-column prop="ssqq" label="所属期起" width="180"></el-table-column>
                          <el-table-column prop="djxh" label="登记序号" width="180"></el-table-column>
                          <el-table-column prop="ewbhxh" label="二维表行序号" width="180"></el-table-column>
                          <el-table-column prop="bnljje" label="本年累计金额" width="180"></el-table-column>
                          <el-table-column prop="ssqz" label="所属期止" width="180"></el-table-column>
                        </el-table>
                    </div>
                    <!-- 企业海关税款缴纳信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'customs_tax_payment_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="realTax" label="近一年企业海关税款缴纳金额" width="240"></el-table-column>
                        <el-table-column prop="cDate" label="最近一次缴税日期" width="160"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 职工医疗保险费欠缴信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'employee_medical_insurance_arrears'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="unpaid_amount" label="欠缴金额" width="180"></el-table-column>
                        <el-table-column prop="remark" label="备注" width="120"></el-table-column>
                        <el-table-column prop="period_of_overdue_payment" label="欠缴月份" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 住房公积金缴纳情况 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'housing_fund_payment_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="zjdwqc" label="组织机构代码" width="200"></el-table-column>
                        <el-table-column prop="gjjjcze" label="公积金缴存总额(元)" width="180"></el-table-column>
                        <el-table-column prop="tgrq" label="公积金缴存总额(元)" width="180"></el-table-column>
                        <el-table-column prop="jcnyq" label="缴存年月起" width="160"></el-table-column>
                        <el-table-column prop="jcrs" label="缴存人数" width="160"></el-table-column>
                        <el-table-column prop="dwzh" label="单位账号" width="180"></el-table-column>
                        <el-table-column prop="jcbl" label="缴存比例" width="180"></el-table-column>
                        <el-table-column prop="jcnyz" label="缴存年月止" width="180"></el-table-column>
                        <el-table-column prop="ccdjrq" label="初次登记日期" width="180"></el-table-column>
                        <el-table-column prop="tgdwqc" label="提供单位全称" width="200"></el-table-column>
                        <el-table-column prop="zjrq" label="征缴日期" width="180"></el-table-column>
                        <el-table-column prop="zfbtjcze" label="住房补贴缴存总额(元)" width="280"></el-table-column>
                        <el-table-column prop="dwxz" label="单位性质" width="180"></el-table-column>
                        <el-table-column prop="xxytbmqc" label="信息源头部门全称" width="180"></el-table-column>
                        <el-table-column prop="zzjgdm" label="组织机构代码" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 省高院开庭信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'court_hearing_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="ah" label="案号" width="220"></el-table-column>
                        <el-table-column prop="aymc" label="案由" width="120"></el-table-column>
                        <el-table-column prop="fymc" label="受理法院" width="180"></el-table-column>
                        <el-table-column prop="ssdw" label="诉讼地位" width="120"></el-table-column>
                        <el-table-column prop="ktrq" label="开庭日期" width="120"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 燃气费信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'gas_fee_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="open_date" label="开户日期" width="220"></el-table-column>
                        <el-table-column prop="statistical_date" label="统计日期" width="120"></el-table-column>
                        <el-table-column prop="is_in_arrears" label="是否欠缴" width="180"></el-table-column>
                        <el-table-column prop="one_household_one_meter" label="每户每度" width="120"></el-table-column>
                        <el-table-column prop="user_address" label="用户地址" width="120"></el-table-column>
                        <el-table-column prop="remark" label="备注" width="120"></el-table-column>
                        <el-table-column prop="monthly_consumption_6" label="6月度用气" width="120"></el-table-column>
                        <el-table-column prop="statistical_base_date" label="统计基础日期" width="120"></el-table-column>
                        <el-table-column prop="monthly_consumption_3" label="3月度用气" width="120"></el-table-column>
                        <el-table-column prop="payment_period" label="缴费周期" width="120"></el-table-column>
                        <el-table-column prop="arrearage_amount" label="欠缴金额" width="120"></el-table-column>
                        <el-table-column prop="advance_amount" label="预缴金额" width="120"></el-table-column>
                        <el-table-column prop="userinfo" label="用户信息" width="120"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 职工医疗保险费变动信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'employee_medical_insurance_change'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="statistical_date" label="统计日期" width="180"></el-table-column>
                        <el-table-column prop="insurance_quantity_change_rate" label="医疗保险费变动率"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                        <el-table-column prop="payment_amount_rate" label="缴费金额变动率"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 海关注册信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'customs_registration_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="cancellationMark" label="注销标志" width="180"></el-table-column>
                        <el-table-column prop="registrationNumber" label="登记号码"></el-table-column>
                        <el-table-column prop="businessCategory" label="业务类别"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 医保定点单位信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'medical_insurance_unit_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="medical_institution_practice_l" label="医保定点单位" width="180"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 公共信用评价信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'enterprise_zhdf'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="area" label="区域" width="180"></el-table-column>
                        <el-table-column prop="pjdj" label="评价等级"></el-table-column>
                        <el-table-column prop="zhdf" label="信用等级"></el-table-column>
                      </el-table>
                    </div>
                    
                    <!-- 终结本次执行案件信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'execution_case_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="executeCourt" label="执行法院" width="180"></el-table-column>
                        <el-table-column prop="caseNumber" label="案号"></el-table-column>
                        <el-table-column prop="endTime" label="终结本次执行案件日期"></el-table-column>
                        <el-table-column prop="executeName" label="被执行人姓名/名称"></el-table-column>
                        <el-table-column prop="filingTime" label="立案时间"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 省高院失信限制高消费信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'court_dishonesty_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="qxrq" label="证件类型" width="120"></el-table-column>
                        <el-table-column prop="lrrq" label="执行法院" width="120"></el-table-column>
                        <el-table-column prop="zjhm" label="列入日期"></el-table-column>
                        <el-table-column prop="zxfymc" label="是否取消"></el-table-column>
                        <el-table-column prop="sfqx" label="取消日期">
                          <template slot-scope="scope">
                            {{ scope.row.sfqx == 1 ? '是' : '否' }}
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <!-- 专利商标质押信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'patent_pledge_info'">
                      <div v-for="(pledgeItem, index) in child.children" :key="index">
                        <div style="font-size: 14px;padding-left: 20px;margin-top:10px">注销信息:</div>
                          <el-table max-height="600" :data="pledgeItem.cancellations" style="width: 100%">
                            <el-table-column prop="applicationNumber" label="申请(专利)号" width="180"></el-table-column>
                            <el-table-column prop="applicantAddress" label="申请(专利权)人地址" width="180"></el-table-column>
                            <el-table-column prop="announcementDate" label="申请日期" width="120"></el-table-column>
                            <el-table-column prop="publicCode" label="公开(公告)号" width="120"></el-table-column>
                            <el-table-column prop="applicantName" label="申请(专利权)人" width="220"></el-table-column>
                            <el-table-column prop="publicDate" label="公开(公告)日期" width="120"></el-table-column>
                            <el-table-column prop="pledgor" label="出质人" width="260"></el-table-column>
                            <el-table-column prop="patentType" label="专利类型"></el-table-column>
                            <el-table-column prop="pledgee" label="质权人" width="260"></el-table-column>
                            <el-table-column prop="pledgeNo" label="质押登记号" width="180"></el-table-column>
                            <el-table-column prop="patentName" label="专利名称" width="120"></el-table-column>
                            <el-table-column prop="inventor" label="发明(设计)人" width="180"></el-table-column>
                            <el-table-column prop="applicationDate" label="申请日期" width="120"></el-table-column>
                            <el-table-column prop="cancellationDate" label="登记解除日" width="120"></el-table-column>
                          </el-table>
                          <div style="font-size: 14px;padding-left: 20px;margin-top:30px">变更信息</div>
                          <el-table max-height="600" :data="pledgeItem.changes" style="width: 100%;margin-top: 20px;">
                            <el-table-column prop="patentName" label="专利名称" width="180"></el-table-column>
                            <el-table-column prop="patentType" label="专利类型" width="180"></el-table-column>
                            <el-table-column prop="applicationNumber" label="申请(专利)号" width="180"></el-table-column>
                            <el-table-column prop="applicantName" label="申请(专利权)人" width="180"></el-table-column>
                            <el-table-column prop="applicantAddress" label="申请(专利权)人地址" width="180"></el-table-column>
                            <el-table-column prop="applicationDate" label="申请日期" width="180"></el-table-column>
                            <el-table-column prop="inventor" label="发明(设计)人" width="180"></el-table-column>
                            <el-table-column prop="publicCode" label="公开(公告)号" width="180"></el-table-column>
                            <el-table-column prop="publicDate" label="公开(公告)日期" width="180"></el-table-column>
                            <el-table-column prop="announcementDate" label="事务公告日" width="180"></el-table-column>
                            <el-table-column prop="pledgeNo" label="质押登记号" width="180"></el-table-column>
                            <el-table-column prop="changeItem" label="变更项" width="180"></el-table-column>
                            <el-table-column prop="changeBefore" label="变更前内容" width="180"></el-table-column>
                            <el-table-column prop="changeAfter" label="变更后内容" width="180"></el-table-column>
                            <el-table-column prop="changeDate" label="变更日" width="180"></el-table-column>
                          </el-table>
                          <div style="font-size: 14px;padding-left: 20px;margin-top:30px">生效中信息</div>
                          <el-table max-height="600" :data="pledgeItem.effective" style="width: 100%;margin-top: 20px;">
                            <el-table-column prop="announcementDate" label="申请日期" width="180"></el-table-column>
                            <el-table-column prop="applicantAddress" label="申请(专利权)人地址" width="180"></el-table-column>
                            <el-table-column prop="applicantName" label="申请(专利权)人" width="180"></el-table-column>
                            <el-table-column prop="applicationDate" label="申请日期" width="180"></el-table-column>
                            <el-table-column prop="applicationNumber" label="申请(专利)号" width="180"></el-table-column>
                            <el-table-column prop="inventor" label="发明(设计)人" width="180"></el-table-column>
                            <el-table-column prop="patentName" label="专利名称" width="180"></el-table-column>
                            <el-table-column prop="patentType" label="专利类型" width="180"></el-table-column>
                            <el-table-column prop="pledgeNo" label="质押登记号" width="180"></el-table-column>
                            <el-table-column prop="pledgee" label="质权人" width="260"></el-table-column>
                            <el-table-column prop="pledgor" label="出质人" width="260"></el-table-column>
                            <el-table-column prop="publicCode" label="公开(公告)号" width="180"></el-table-column>
                            <el-table-column prop="publicDate" label="公开(公告)日期" width="180"></el-table-column>
                            <el-table-column prop="registrationDate" label="登记日" width="180"></el-table-column>
                          </el-table>
                        </div>
                    </div>
                    <!-- 水费信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'water_fee_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="open_date" label="开户日期" width="180"></el-table-column>
                        <el-table-column prop="statistical_date" label="统计日期" width="180"></el-table-column>
                        <el-table-column prop="payment_detail" label="缴费详情"></el-table-column>
                        <el-table-column prop="prepaid_amount" label="预缴金额"></el-table-column>
                        <el-table-column prop="is_in_arrears" label="是否欠费"></el-table-column>
                        <el-table-column prop="one_household_one_meter" label="是否单户单表" width="120"></el-table-column>
                        <el-table-column prop="user_address" label="用户地址" width="180"></el-table-column>
                        <el-table-column prop="arrears_amount" label="欠费金额"></el-table-column>
                        <el-table-column prop="monthly_consumption_6" label="月度用水金额" width="120"></el-table-column>
                        <el-table-column prop="statistical_base_date" label="统计日期" width="150"></el-table-column>
                        <el-table-column prop="monthly_consumption_3" label="3月用水金额" width="120"></el-table-column>
                        <el-table-column prop="payment_period" label="缴费周期" width="120"></el-table-column>
                        <el-table-column prop="userinfo" label="用户信息" width="120"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 增值税缴税信息接口 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'vat_payment_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="qynjsrq" label="企业缴纳日期" width="300"></el-table-column>
                        <el-table-column prop="zjyczcjsrq" label="最近一次正常抄税日期" width="180"></el-table-column>
                        <el-table-column prop="zzssjse" label="增值税实际缴纳额"></el-table-column>
                        <el-table-column prop="zzsynse" label="增值税应纳税额"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 社会保险费欠缴信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'social_insurance_arrears_interface'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="qjtjksrq" label="缴纳日期" width="180"></el-table-column>
                        <el-table-column prop="sxyzcd" label="社保编号" width="120"></el-table-column>
                        <el-table-column prop="sxxwyxq" label="社保类型"></el-table-column>
                        <el-table-column prop="qjjehj" label="欠缴金额"></el-table-column>
                        <el-table-column prop="qjtjjzrq" label="欠缴日期"></el-table-column>
                        <el-table-column prop="qjsd" label="欠缴状态"></el-table-column>
                        <el-table-column prop="sfbj" label="是否欠费"></el-table-column>
                        <el-table-column prop="zzjgdm" label="登记号码"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 企业所得税缴税信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'corporate_income_tax_info'">
                      <el-table max-height="500" :data="child.children" style="width: 100%">
                        <el-table-column prop="qysdsynse" label="企业所得税应纳税额" width="200"></el-table-column>
                        <el-table-column prop="qynjsrq" label="企业缴纳日期" width="200"></el-table-column>
                        <el-table-column prop="zjyczcjsrq" label="最近一次正常抄税日期" width="200"></el-table-column>
                        <el-table-column prop="qysdssjse" label="实缴税款金额" width="200"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 海关信用等级信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'customs_credit_rating_info'">
                      <el-table max-height="500" :data="child.children" style="width: 100%">
                        <el-table-column prop="enterpriseName" label="查询企业名称" width="200"></el-table-column>
                        <el-table-column prop="uniscId" label="查询企业统一社会信用代码" width="200"></el-table-column>
                        <el-table-column prop="applicableTime" label="适用信用等级时间" width="200"></el-table-column>
                        <el-table-column prop="registrationNumber" label="海关注册编码(企业注册号)" width="200"></el-table-column>
                        <el-table-column prop="creditRating" label="信用等级"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 破产案件信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'bankruptcy_case_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="acceptanceCourt" label="受理法院" width="180"></el-table-column>
                        <el-table-column prop="closingTime" label="结案时间" width="120"></el-table-column>
                        <el-table-column prop="closingMethod" label="结案方式" width="180"></el-table-column>
                        <el-table-column prop="caseNumber" label="案号" width="220"></el-table-column>
                        <el-table-column prop="acceptanceTime" label="受理时间" width="120"></el-table-column>
                        <el-table-column prop="managerName" label="管理人名称"  width="120"></el-table-column>
                        <el-table-column prop="caseType" label="案件类型" width="120"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 纳税信用等级A级信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'class_a_taxpayer_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="evaluation_year" label="评价年度" width="180"></el-table-column>
                        <el-table-column prop="tax_credit_rating" label="纳税信用等级"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 行政许可信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'administrative_license_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="administrativeOrgUniscId" label="行政机关统一社会信用代码" width="220" fixed=""></el-table-column>
                        <el-table-column prop="licensingType" label="许可类型"></el-table-column>
                        <el-table-column prop="licensingState" label="许可状态">
                          <template slot-scope="scope">
                            {{ scope.row.licensingState == '1' ? '有效' : '无效' }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="licensingValidityDateEnd" label="许可有效期止" width="120"></el-table-column>
                        <el-table-column prop="licensingDecisionName" label="许可决定名称" width="180"></el-table-column>
                        <el-table-column prop="licensingValidityDateBegin" label="许可有效期起" width="120"></el-table-column>
                        <el-table-column prop="licensingNumber" label="许可证号" width="200"></el-table-column>
                        <el-table-column prop="licensingName" label="许可证名称" width="200"></el-table-column>
                        <el-table-column prop="licensingDecisionDate" label="许可决定日期" width="120"></el-table-column>
                        <el-table-column prop="licensingContent" label="许可内容" width="200"></el-table-column>
                        <el-table-column prop="dataSource" label="数据来源" width="200"></el-table-column>
                        <el-table-column prop="licensingDecisionNumber" label="许可决定文号" width="200"></el-table-column>
                        <el-table-column prop="administrativeOrgName" label="行政机关名称" width="200"></el-table-column>
                      </el-table>
                    </div>
                     <!-- 企业行政处罚信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'administrative_punishment_info'">
                      <el-table max-height="600" :data="child.children[0].dataInfo" style="width: 100%">
                        <el-table-column prop="administrativeOrgName" label="行政处罚机构名称" width="180"></el-table-column>
                        <el-table-column prop="administrativeOrgUniscId" label="行政处罚机构统一社会信用代码"></el-table-column>
                        <el-table-column prop="dataSource" label="数据来源"></el-table-column>
                        <el-table-column prop="enterpriseCategory" label="市场主体类型"></el-table-column>
                        <el-table-column prop="enterpriseName" label="企业名称"></el-table-column>
                        <el-table-column prop="legalPersonName" label="法人名称"></el-table-column>
                        <el-table-column prop="publicityDeadline" label="公示截止日期" width="120"></el-table-column>
                      </el-table>
                    </div>
                     <!-- 软件著作权信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'software_copyright_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="classifyNumber" label="分类号"></el-table-column>
                        <el-table-column prop="softwareFullName" label="软件全称"></el-table-column>
                        <el-table-column prop="registrationNumber" label="登记号"></el-table-column>
                        <el-table-column prop="registrationDate" label="登记日期" width="120"></el-table-column>
                        <el-table-column prop="versionNumber" label="版本号"></el-table-column>
                      </el-table>
                    </div>
                    <!-- 省高院知识产权涉诉信息 -->
                    <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'court_intellectual_property_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="fymc" label="法院名称"></el-table-column>
                        <el-table-column prop="ssdw" label="被告"></el-table-column>
                        <el-table-column prop="ah" label="案号"></el-table-column>
                        <el-table-column prop="jarq" label="注册日期" width="120"></el-table-column>
                      </el-table>
                    </div>

                    <!-- 环评信用信息 -->
                     <div style="margin-bottom: 10px;" v-if="expandedChildItems[`${item.id}-${child.id}`] && child.englishName == 'environmental_credit_info'">
                      <el-table max-height="600" :data="child.children" style="width: 100%">
                        <el-table-column prop="pjdj" label="环评信用等级"></el-table-column>
                        <el-table-column prop="item_score" label="环评信用积分"></el-table-column>
                        <el-table-column prop="pjrq" label="环评日期"></el-table-column>
                      </el-table>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  selectAllDataByEnterprise
} from "../../api/auth";
import baseUrl from "@/api/baseUrl";
export default {
  data() {
    return {
      showLog:false,
      expandedItems: {}, // 用于存储每个一级节点的展开状态
      expandedChildItems: {}, // 用于存储每个二级节点的展开状态
      searchForm: {
        name:'',//名字
        enterpriseCode:'',
        page: 1,
        pageSize: 1000
      },
      tree: [
        {
          id: 1,
          label: "市场主体登记信息",
          children: [
            {
              id: 2,label: "市场主体登记信息",englishName:'registration_info'
            }
          ]
        },
        {
          id: 3,
          label: "纳税信息",
          children: [
            { id: 5, label: "非正常纳税户信息",englishName:'abnormal_taxpayer_info'  },
            { id: 11, label: "财务申报信息",englishName:'financial_reporting_info'  },
            { id: 14, label: "增值税缴税信息",englishName:'vat_payment_info'  },
            { id: 15, label: "企业所得税缴税信息",englishName:'corporate_income_tax_info'  },
            { id: 16, label: "纳税信用等级A级信息",englishName:'class_a_taxpayer_info'  },
            { id: 9, label: "企业缓税信息",englishName:'tax_deferral_info'  },
            { id: 129, label: "历史欠税信息",englishName:'historical_tax_arrears_info'  },
          ]
        },
        {
          id: 81,
          label: "司法信息",
          children: [
            { id: 82, label: "省高院开庭信息",englishName:'court_hearing_info'  },
            { id: 83, label: "省高院失信限制高消费信息",englishName:'court_dishonesty_info'  },
            { id: 85, label: "法院判决信息",englishName:'court_judgment_info'  },
            { id: 86, label: "破产案件信息",englishName:'bankruptcy_case_info'  },
            { id: 87, label: "终结本次执行案件信息",englishName:'execution_case_info'  },
            // { id: 88, label: "被执行人信息",englishName:'executed_person_info' }
          ]
        },
        {
          id: 68,
          label: "进出口信息",
          children: [
            // { id: 69, label: "基础信息",englishName:'enterprise_basic_info'  },
            { id: 71, label: "海关注册信息",englishName:'customs_registration_info'  },
            { id: 72, label: "海关信用等级信息",englishName:'customs_credit_rating_info' },
            { id: 70, label: "企业海关税款缴纳信息",englishName:'customs_tax_payment_info'  },
          ]
        },
        {
          id: 73,
          label: "生态环境领域信息",
          children: [
            // { id: 74, label: "碳排放信息",englishName:'carbon_emission_info'  },
            { id: 75, label: "环评信用信息",englishName:'environmental_credit_info'  },
          ]
        },
        {
          id: 34,
          label: "社会保险信息",
          children: [
            { id: 21, label: "企业职工基本养老保险缴费信息",englishName:'pension_insurance_payment_info'  },
            { id: 23, label: "职工医疗保险费基本信息",englishName:'employee_medical_insurance_info'  },
            { id: 24, label: "职工医疗保险费欠缴信息",englishName:'employee_medical_insurance_arrears'  },
            { id: 25, label: "职工医疗保险费变动信息",englishName:'employee_medical_insurance_change' },
            { id: 19, label: "社会保险费缴纳情况",englishName:'social_insurance_payment_info'},
            { id: 20, label: "社会保险费欠缴信息",englishName:'social_insurance_arrears_interface'  },
          ]
        },
        {
          id: 62,
          label: "知识产权信息",
          children: [
            { id: 64, label: "企业商标信息",englishName:'enterprise_trademark_info'  },
            { id: 66, label: "软件著作权信息",englishName:'software_copyright_info'  },
            { id: 67, label: "专利商标质押信息",englishName:'patent_pledge_info' },
            // { id: 65, label: "专利信息",englishName:'enterprise_patent_info'  },
            { id: 63, label: "省高院知识产权涉诉信息",englishName:'court_intellectual_property_info'  },
          ]
        },
        {
          id: 33,
          label: "不动产登记信息",
          children: [
            { id: 28, label: "企业主名下不动产登记信息",englishName:'enterprise_real_estate_info'  },
            { id: 29, label: "企业主名下不动产抵押信息",englishName:'enterprise_real_estate_mortgage'  },
          ]
        },
        {
          id: 46,
          label: "科技研发信息",
          children: [
            { id: 47, label: "科技研发信息",englishName:'technology_rd_info'  },
            // { id: 48, label: "企业创新评价信息",englishName:'enterprise_innovation_evaluation' }
          ]
        },
        {
          id: 49,
          label: "新型农业经营主体信息",
          children: [
            { id: 51, label: "基本信息",englishName:'agricultural_basic_info'  },
            { id: 52, label: "经营信息",englishName:'agricultural_operation_info'  },
            { id: 54, label: "保险信息",englishName:'agricultural_insurance_info'  },
            { id: 55, label: "补贴信息",englishName:'agricultural_subsidy_info'  },
            // { id: 50, label: "新型农业经营主体信息",englishName:'new_agricultural_entity_info'  },
            // { id: 53, label: "土地经营权流转信息",englishName:'agricultural_land_transfer_info'  },
          ]
        },
        {
          id: 200,
          label: "涉农类清单信息",
          children: [
            { id: 201, label: "涉农类清单信息",englishName:'agricultural_list_info' },
          ]
        },
        {
          id: 59,
          label: "资质信息",
          children: [
            { id: 60, label: "行政许可信息",englishName:'administrative_license_info'  },
            // { id: 61, label: "运输资质信息",englishName:'transport_qualification_info' }
          ]
        },
        {
          id: 76,
          label: "医保定点信息",
          children: [
            { id: 77, label: "医保定点单位信息",englishName:'medical_insurance_unit_info'  },
            { id: 78, label: "医保定点民营医疗机构信息",englishName:'private_medical_insurance_info'  },
          ]
        },
        {
          id: 36,
          label: "水电气费缴纳信息",
          children: [
            { id: 37, label: "水费信息",englishName:'water_fee_info'  },
            { id: 38, label: "电费信息",englishName:'electricity_fee_info'  },
            { id: 39, label: "燃气费信息",englishName:'gas_fee_info'  },
            // { id: 40, label: "法人用水缴费信息",englishName:'legal_person_water_payment'  },
            // { id: 41, label: "法人用水拖欠费信息",englishName:'legal_person_water_arrears'  },
            // { id: 42, label: "法人用气缴费信息",englishName:'legal_person_gas_payment'  },
            // { id: 43, label: "法人用气拖欠费信息",englishName:'legal_person_gas_arrears'  },
            // { id: 44, label: "法人用电信息查询",englishName:'legal_person_electricity_query'  },
            // { id: 45, label: "法人用电欠费信息查询",englishName:'legal_person_electricity_arrears' }
          ]
        },
        {
          id: 89,
          label: "企业行政处罚信息",
          children: [
            { id: 91, label: "企业行政处罚信息",englishName:'administrative_punishment_info'  },
          ]
        },
        {
          id: 205,
          label: "企业行政强制信息",
          children: [
            { id: 92, label: "企业行政强制信息",englishName:'administrative_force_info'  },
          ]
        },
        {
          id: 206,
          label: "企业黑名单信息",
          children: [
            { id: 93, label: "企业黑名单信息",englishName:'blacklist_info'  }
          ]
        },
        {
          id: 207,
          label: "自然人黑名单接口",
          children: [
            { id: 208, label: "自然人黑名单接口",englishName:'person_black_info'  }
          ]
        },
        {
          id: 35,
          label: "住房公积金缴纳情况",
          children: [
            { id: 17, label: "住房公积金缴纳情况",englishName:'housing_fund_payment_info'  },
            // { id: 18, label: "法人公积金欠缴信息",englishName:'legal_person_housing_fund_arrears' }
          ]
        },
        {
          id: 100,
          label: "企业公共信用评价",
          children: [
            {
              id: 101,label: "企业公共信用评价",englishName:'enterprise_zhdf'
            }
          ]
        },
      ],
      tree2: [
        {
          id: 1,
          label: "市场主体登记信息",
          children: [
            {
              id: 2,label: "市场主体登记信息",englishName:'registration_info'
            }
          ]
        },
        {
          id: 3,
          label: "纳税信息",
          children: [
            { id: 5, label: "非正常纳税户信息",englishName:'abnormal_taxpayer_info'  },
            { id: 11, label: "财务申报信息",englishName:'financial_reporting_info'  },
            { id: 14, label: "增值税缴税信息",englishName:'vat_payment_info'  },
            { id: 15, label: "企业所得税缴税信息",englishName:'corporate_income_tax_info'  },
            { id: 16, label: "纳税信用等级A级信息",englishName:'class_a_taxpayer_info'  },
            { id: 9, label: "企业缓税信息",englishName:'tax_deferral_info'  },
            { id: 129, label: "历史欠税信息",englishName:'historical_tax_arrears_info'  },
          ]
        },
        {
          id: 81,
          label: "司法信息",
          children: [
            { id: 82, label: "省高院开庭信息",englishName:'court_hearing_info'  },
            { id: 83, label: "省高院失信限制高消费信息",englishName:'court_dishonesty_info'  },
            { id: 85, label: "法院判决信息",englishName:'court_judgment_info'  },
            { id: 86, label: "破产案件信息",englishName:'bankruptcy_case_info'  },
            { id: 87, label: "终结本次执行案件信息",englishName:'execution_case_info'  },
            // { id: 88, label: "被执行人信息",englishName:'executed_person_info' }
          ]
        },
        {
          id: 68,
          label: "进出口信息",
          children: [
            // { id: 69, label: "基础信息",englishName:'enterprise_basic_info'  },
            { id: 71, label: "海关注册信息",englishName:'customs_registration_info'  },
            { id: 72, label: "海关信用等级信息",englishName:'customs_credit_rating_info' },
            { id: 70, label: "企业海关税款缴纳信息",englishName:'customs_tax_payment_info'  },
          ]
        },
        {
          id: 73,
          label: "生态环境领域信息",
          children: [
            // { id: 74, label: "碳排放信息",englishName:'carbon_emission_info'  },
            { id: 75, label: "环评信用信息",englishName:'environmental_credit_info'  },
          ]
        },
        {
          id: 34,
          label: "社会保险信息",
          children: [
            { id: 21, label: "企业职工基本养老保险缴费信息",englishName:'pension_insurance_payment_info'  },
            { id: 23, label: "职工医疗保险费基本信息",englishName:'employee_medical_insurance_info'  },
            { id: 24, label: "职工医疗保险费欠缴信息",englishName:'employee_medical_insurance_arrears'  },
            { id: 25, label: "职工医疗保险费变动信息",englishName:'employee_medical_insurance_change' },
            { id: 19, label: "社会保险费缴纳情况",englishName:'social_insurance_payment_info'},
            { id: 20, label: "社会保险费欠缴信息",englishName:'social_insurance_arrears_interface'  },
          ]
        },
        {
          id: 62,
          label: "知识产权信息",
          children: [
            { id: 64, label: "企业商标信息",englishName:'enterprise_trademark_info'  },
            { id: 66, label: "软件著作权信息",englishName:'software_copyright_info'  },
            { id: 67, label: "专利商标质押信息",englishName:'patent_pledge_info' },
            // { id: 65, label: "专利信息",englishName:'enterprise_patent_info'  },
            { id: 63, label: "省高院知识产权涉诉信息",englishName:'court_intellectual_property_info'  },
          ]
        },
        {
          id: 33,
          label: "不动产登记信息",
          children: [
            { id: 28, label: "企业主名下不动产登记信息",englishName:'enterprise_real_estate_info'  },
            { id: 29, label: "企业主名下不动产抵押信息",englishName:'enterprise_real_estate_mortgage'  },
          ]
        },
        {
          id: 46,
          label: "科技研发信息",
          children: [
            { id: 47, label: "科技研发信息",englishName:'technology_rd_info'  },
            // { id: 48, label: "企业创新评价信息",englishName:'enterprise_innovation_evaluation' }
          ]
        },
        {
          id: 49,
          label: "新型农业经营主体信息",
          children: [
            { id: 51, label: "基本信息",englishName:'agricultural_basic_info'  },
            { id: 52, label: "经营信息",englishName:'agricultural_operation_info'  },
            { id: 54, label: "保险信息",englishName:'agricultural_insurance_info'  },
            { id: 55, label: "补贴信息",englishName:'agricultural_subsidy_info'  },
            // { id: 50, label: "新型农业经营主体信息",englishName:'new_agricultural_entity_info'  },
            // { id: 53, label: "土地经营权流转信息",englishName:'agricultural_land_transfer_info'  },
          ]
        },
        {
          id: 200,
          label: "涉农类清单信息",
          children: [
            { id: 201, label: "涉农类清单信息",englishName:'agricultural_list_info' },
          ]
        },
        {
          id: 59,
          label: "资质信息",
          children: [
            { id: 60, label: "行政许可信息",englishName:'administrative_license_info'  },
            // { id: 61, label: "运输资质信息",englishName:'transport_qualification_info' }
          ]
        },
        {
          id: 76,
          label: "医保定点信息",
          children: [
            { id: 77, label: "医保定点单位信息",englishName:'medical_insurance_unit_info'  },
            { id: 78, label: "医保定点民营医疗机构信息",englishName:'private_medical_insurance_info'  },
          ]
        },
        {
          id: 36,
          label: "水电气费缴纳信息",
          children: [
            { id: 37, label: "水费信息",englishName:'water_fee_info'  },
            { id: 38, label: "电费信息",englishName:'electricity_fee_info'  },
            { id: 39, label: "燃气费信息",englishName:'gas_fee_info'  },
            // { id: 40, label: "法人用水缴费信息",englishName:'legal_person_water_payment'  },
            // { id: 41, label: "法人用水拖欠费信息",englishName:'legal_person_water_arrears'  },
            // { id: 42, label: "法人用气缴费信息",englishName:'legal_person_gas_payment'  },
            // { id: 43, label: "法人用气拖欠费信息",englishName:'legal_person_gas_arrears'  },
            // { id: 44, label: "法人用电信息查询",englishName:'legal_person_electricity_query'  },
            // { id: 45, label: "法人用电欠费信息查询",englishName:'legal_person_electricity_arrears' }
          ]
        },
        {
          id: 89,
          label: "企业行政处罚信息",
          children: [
            { id: 91, label: "企业行政处罚信息",englishName:'administrative_punishment_info'  },
          ]
        },
        {
          id: 205,
          label: "企业行政强制信息",
          children: [
            { id: 92, label: "企业行政强制信息",englishName:'administrative_force_info'  },
          ]
        },
        {
          id: 206,
          label: "企业黑名单信息",
          children: [
            { id: 93, label: "企业黑名单信息",englishName:'blacklist_info'  }
          ]
        },
        {
          id: 207,
          label: "自然人黑名单接口",
          children: [
            { id: 208, label: "自然人黑名单接口",englishName:'person_black_info'  }
          ]
        },
        {
          id: 35,
          label: "住房公积金缴纳情况",
          children: [
            { id: 17, label: "住房公积金缴纳情况",englishName:'housing_fund_payment_info'  },
            // { id: 18, label: "法人公积金欠缴信息",englishName:'legal_person_housing_fund_arrears' }
          ]
        },
        {
          id: 100,
          label: "企业公共信用评价",
          children: [
            {
              id: 101,label: "企业公共信用评价",englishName:'enterprise_zhdf'
            }
          ]
        },
      ],
      time: 0,
    };
  },
  mounted() {
    this.showLog = false;
    this.time = 0;
  },
  methods: {
    // 切换展开/折叠状态
    toggleExpand(id) {
      this.$set(this.expandedItems, id, !this.expandedItems[id]);
    },
    // 切换二级节点展开/折叠状态
    toggleExpandChild(parentId, childId) {
      const key = `${parentId}-${childId}`;
      this.$set(this.expandedChildItems, key, !this.expandedChildItems[key]);
    },
    downJson (e) {
      if(this.searchForm.enterpriseCode || this.searchForm.name){
        const xhr = new XMLHttpRequest();
        xhr.open("get", baseUrl + "api/v1/queryData/downAllList" + '?page=' + this.searchForm.page + '&pageSize=' + this.searchForm.pageSize+ '&name=' + this.searchForm.name+ '&enterpriseCode=' + this.searchForm.enterpriseCode, true);  // get、post都可
        xhr.responseType = "blob";  // 转换流
        xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.onload = function () {
          if (this.status === 200) {
            const blob = this.response;
            const fileName = "授权书列表下载.xlsx";
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              const a = document.createElement("a")
              const url = window.URL.createObjectURL(blob);
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click()
              window.URL.revokeObjectURL(url)
            }
          }
        }
        xhr.send();
      }else{
        this.$message.warning("请输入统一社会信用代码或企业名称！");
      }
    },
    showOneTag(item){
      var flag = false;
      item.children.forEach(child => {
        if(child.children && child.children.length > 0){
          flag = true;
        }
      })
      return flag;
    },
    // 搜索
    searchFunction() {
      if(this.searchForm.enterpriseCode || this.searchForm.name){
        this.selectAllDataByEnterpriseApi()
      }else{
        this.$message.warning("请输入统一社会信用代码或企业名称！");
      }
    },
    async selectAllDataByEnterpriseApi() {
      this.tree = JSON.parse(JSON.stringify(this.tree2))
      this.expandedItems= {} // 用于存储每个一级节点的展开状态
      this.expandedChildItems= {} // 用于存储每个二级节点的展开状态
      const res = await selectAllDataByEnterprise(this.searchForm);
      console.log(res.data,'1111111111')
      if(res.data.code == 202 && res.data.data == null){
        this.showLog = true;
        this.time = 0;
      }else{
        this.showLog = false
        for (const key in res.data.data) {
          this.tree.forEach(treeItem => {
            treeItem.children.forEach(child => {
              if(child.englishName === 'financial_reporting_info' && key === 'financial_reporting_info'){
                console.log(22222222222222223333333333333333333)
              }
              if(child.englishName === key && res.data.data[key] && (res.data.data[key].length > 0 || res.data.data[key] !== null)){
                this.$set(child, 'children', res.data.data[key])
                // 默认展开二级节点
                this.$set(this.expandedChildItems, `${treeItem.id}-${child.id}`, true)
                // 默认展开一级节点
                this.$set(this.expandedItems, treeItem.id, true)
              }
            })
          })
        }
        this.time = 1;
        console.log(this.tree)
      }
    },
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 787px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  padding-bottom: 30px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }
  .contentClass{
    margin-top: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .itemDiv{
    width: 100%;
    padding:0 30px;
    box-sizing: border-box;
    .headerName{
      font-size: 18px;
      font-weight: bolder;
    }
    .contentArea{
      box-sizing: border-box;
      border: 1px solid #dcdfe6;
      width: 80%;
      padding: 20px 30px;
      display: flex;
      margin-bottom: 10px;
      justify-content: space-between;
      flex-wrap: wrap;
      .itemLine{
        width: 48%;
        font-size: 16px;
        box-sizing: border-box;
        padding: 5px 0;
      }
    }
    .contentArea2{
      box-sizing: border-box;
      width: 80%;
      display: flex;
      flex-wrap: wrap;
      .itemLine2{
        width: 48%;
        font-size: 14px;
        box-sizing: border-box;
        padding: 5px 0;
      }
    }
  }
}
.lines {
  width: 3px;
  height: 15px;
  background: #0081cc;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}

.arrow-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.arrow-icon:not(.triangle) {
  /* 一级标题的箭头图标样式 */
  font-size: 12px;
}

.arrow-icon:not(.triangle).expanded {
  transform: rotate(0deg);
}

.arrow-icon:not(.triangle):not(.expanded) {
  transform: rotate(-90deg);
}

.arrow-icon.triangle {
  position: relative;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 10px solid #333;
  margin-right: 8px;
  cursor: pointer;
}

.arrow-icon.triangle.expanded {
  transform: rotate(0deg);
}

.arrow-icon.triangle:not(.expanded) {
  transform: rotate(-90deg);
}
::v-deep .el-table__header-wrapper {
    border-bottom: solid 1px #ebeef5 !important;
}
</style>